export default __webpack_public_path__ + "static/media/ipad-system-volume-02.d705ed5e.svg";